import { BibliographicReference } from '@livv/models';
import { getBibliographicReferenceUrl } from '@livv/utils/helpers/decisions';
import { Box, Link, SxProps, Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import BlockTitle from '../components/BlockTitle';
import SideContentCard from '@components/SideContentCard';
import useUser from '@utils/context/user';
import { UIExtraContentType } from '@utils/types/search';

const listSx: SxProps = {
    marginBlockEnd: 0,
    marginBlockStart: 0,
    paddingInlineStart: 3,
};

interface BibliographyProps {
    bibliography: BibliographicReference[];
}

const Bibliography: FC<BibliographyProps> = ({ bibliography }) => {
    const { t } = useTranslation('common');
    const { privileges } = useUser();

    return (
        <Box>
            <BlockTitle
                modelType={UIExtraContentType.BIBLIOGRAPHY}
                title={t('bibliography.labelRessourceCount', { count: bibliography.length })}
            />
            <SideContentCard>
                <Box component="ul" sx={listSx}>
                    {bibliography.map((reference) => {
                        const { text } = reference;
                        // Business rule: these URLs target paid platforms only internal lawyers can access.
                        const url = privileges?.isInternalUser
                            ? getBibliographicReferenceUrl(reference)
                            : undefined;

                        return (
                            <Typography
                                key={`${text}-${url}`}
                                color="textSecondary"
                                component="li"
                                gutterBottom
                            >
                                {url ? (
                                    <Link
                                        href={url}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        underline="hover"
                                    >
                                        {text}
                                    </Link>
                                ) : (
                                    text
                                )}
                            </Typography>
                        );
                    })}
                </Box>
            </SideContentCard>
        </Box>
    );
};

export default Bibliography;
